<template>
  <div class="container bg-brand-taupe-100 p-4 mb-4 rounded-md shadow-md">
    <div>
      <h2 class="text-brand-blue-400 font-bold text-2xl mb-0"> {{ review.title }} </h2>
    </div>
    <div class="flex-row md:flex justify-between text-lg mb-4 md:mb-0">
      <!-- <div>
        <h5 class="text-brand-blue-400 font-bold inline-block mr-2">Reference:</h5>
        # {{ review.reference }}
      </div> -->
      <div>
        <h5 class="font-semibold text-brand-blue-400 inline-block mr-2">Date Started:</h5>
        {{ $moment(review.created_at).format("DD MMM YYYY") }}
      </div>
      <div>
        <h5 class="font-semibold text-brand-blue-400 inline-block mr-2">Status:</h5>
        {{ statusText(this.review.status) }}
      </div>
    </div>
    <div>
      <div v-if="review.body">
        <h5 class="font-semibold text-brand-blue-400 inline-block mt-4 mr-2">Description:</h5>
        <div>
          {{ review.body }}
        </div>
      </div>
      <div>
        <div>
          <h4 class="text-sm">
            <Link class="" :href="`/reviews/${review.id}/edit`">
            <button class="
          bg-brand-blue-400
          hover:bg-brand-blue-200
          text-white
          font-bold
          mt-6
          py-2
          px-4
          rounded
          justify-right
          uppercase
        ">
              <div v-if="this.review.status === 'in_progress' || this.review.status === 'new'">
                EDIT
              </div>
              <div v-else-if="this.review.status === 'submitted'">
                VIEW
              </div>
            </button>
            </Link>
          </h4>
        </div>
      </div>
    </div>
  </div>

  <!-- {{ review }} -->
</template>

<script>

export default {
  props: {
    review: Object,
  },
  methods: {
    statusText(status) {
      switch (status) {
        // 'new','in_progress','submitted','deleted'
        case 'new':
          return 'new';
          break;
        case 'in_progress':
          return 'In Progress';
          break;
        case 'submitted':
          return 'Submitted'
          break;
        case 'deleted':
          return 'Deleted'
          break;
        default:
          return 'Unknown';
      }
    },
    onClickView(review) {
      this.$inertia.visit('/reviews/show/' + review.id, {
        method: 'get',
      })
    }
  },
}
</script>